import React, { forwardRef } from "react";
import classNames from "classnames";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import { useJson } from "../Hooks/useJson";

export interface ISchemaProps extends IEditableProps, IStyledProps {
    jsonSchema: string
}

const Schema = forwardRef((props: ISchemaProps, ref: any) => {
    const { jsonSchema } = props;
    useJson(jsonSchema);

    const isBuildr = props.editorClassObj && props.editorClassObj.includes("CMS_WIDGET");

    return (
        isBuildr ?
            <div className={classNames("border p-3 text-muted font-italic", props.editorClassObj)} ref={ref} data-id={props.cmsId}>
                {jsonSchema}
            </div>
        : null
    );
});

export default Schema;